export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

export interface EmailValidationResult {
  isValid: boolean;
  error: string;
}

export class ValidationService {
  static validatePassword(
    password: string,
    confirmPassword?: string,
  ): PasswordValidationResult {
    const errors: string[] = [];

    if (!password) {
      errors.push('Password is required.');
      return { isValid: false, errors };
    }

    if (password.length < 8) {
      errors.push('Password must be at least 8 characters.');
    }

    if (confirmPassword !== undefined && password !== confirmPassword) {
      errors.push('Passwords do not match.');
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }

  static validatePasswordReset(
    password: string,
    confirmPassword: string,
  ): PasswordValidationResult {
    if (!password || !confirmPassword) {
      return {
        isValid: false,
        errors: ['Both password fields are required.'],
      };
    }

    return this.validatePassword(password, confirmPassword);
  }

  static validateEmail(email: string): EmailValidationResult {
    if (!email) {
      return {
        isValid: false,
        error: 'Email is required',
      };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return {
      isValid: emailRegex.test(email),
      error: emailRegex.test(email) ? '' : 'Please enter a valid email address',
    };
  }
}
